import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'constants/constants'

export const useStyles = makeStyles((theme) => ({
  root: {
    color: '#262626',
    // backgroundColor: theme.palette.background.default,
  },
  tabRoot: {
    minHeight: 43,
  },
  tabs: {
    background: COLORS.neutral.shade50,
    minHeight: 43,
    '& .MuiTabs-scrollButtonsDesktop': {
      [theme.breakpoints.down('md')]: {
        display: 'inherit',
      },
    },
    '& .MuiTabs-scrollButtons': {
      transition: '0.3s width',
      '&.Mui-disabled': {
        width: 0,
      },
    },
  },
  indicator: {
    backgroundColor: '#ed154e',
  },
  label: {
    textTransform: 'none',
    maxWidth: '16rem',
    fontWeight: 'bold',
    color: COLORS.neutral.shade500,
  },
  active: {
    color: '#ed154e',
    fontWeight: 'bold',
  },
}))
